import { useEffect, useMemo, useRef, useState } from 'react';
import { Button, convertHTMLToRichText, FullColumn, RichTextViewer, Row, Typography } from 'seagull';
import { CheckSmall } from 'seagull/icons';
import { useStoreActions } from "../../../../../store/store-context";
import styles from "./SuggestedDescriptionDisplay.module.scss";
import { isPromptQuestion, SuggestedDescriptionDisplayTestIds } from "./SuggestedDescriptionDisplay.utils";
import { useScrollDetection } from "./useScrollDetection";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SuggestedDescriptionDisplay = _ref => {
  let {
    isLoading,
    isUndoLoading = false,
    suggestedDescription,
    hasServiceDescription,
    conversationId,
    canUndo,
    isClarification,
    onAccept,
    onInsert,
    onUndo,
    isInserting = false
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const [hasServiceDescriptionAtInsert, setHasServiceDescriptionAtInsert] = useState(null);
  const contentRef = useRef(null);
  const parsedRichText = useMemo(() => suggestedDescription != null ? convertHTMLToRichText(suggestedDescription) : null, [suggestedDescription]);
  const {
    hasScroll,
    isAtBottom
  } = useScrollDetection(contentRef, [suggestedDescription, isLoading, parsedRichText]);
  useEffect(() => {
    setHasServiceDescriptionAtInsert(null);
  }, [suggestedDescription]);
  const handleInsertButtonClick = () => {
    if (parsedRichText && onInsert) {
      logBI(hasServiceDescription ? 17003 : 17002);
      onInsert(parsedRichText);
      setHasServiceDescriptionAtInsert(hasServiceDescription);
      conversationId !== '' && onAccept(conversationId);
    }
  };
  const handleUndoClick = () => {
    logBI(17008);
    onUndo();
  };
  const handleCopy = () => {
    if (suggestedDescription && !isPromptQuestion(suggestedDescription)) {
      const textCopied = isClarification ? suggestedDescription : (() => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = suggestedDescription;
        return tempDiv.textContent || tempDiv.innerText || '';
      })();
      logBI(17010, {
        textCopied
      });
    }
  };
  if (isLoading) {
    return /*#__PURE__*/_jsx(Typography, {
      "data-testid": SuggestedDescriptionDisplayTestIds.Loading(),
      variant: "paragraph1",
      weight: "normal",
      className: styles.textWithDots,
      children: "Working on it..."
    });
  }
  if (isClarification || isPromptQuestion(suggestedDescription)) {
    return /*#__PURE__*/_jsx(RichTextViewer, {
      value: suggestedDescription !== null && suggestedDescription !== void 0 ? suggestedDescription : '',
      "data-testid": SuggestedDescriptionDisplayTestIds.SuggestedDescription()
    });
  }
  return /*#__PURE__*/_jsxs(FullColumn, {
    className: styles.root,
    justifyContent: "space-between",
    "data-testid": SuggestedDescriptionDisplayTestIds.Root(),
    children: [/*#__PURE__*/_jsx(FullColumn, {
      className: styles.content,
      children: /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        className: styles.contentWrapper,
        children: parsedRichText && /*#__PURE__*/_jsx("div", {
          className: styles.descriptionContent,
          onCopy: handleCopy,
          children: /*#__PURE__*/_jsx(RichTextViewer, {
            value: parsedRichText,
            "data-testid": SuggestedDescriptionDisplayTestIds.SuggestedDescription()
          })
        })
      })
    }), parsedRichText && !isPromptQuestion(suggestedDescription) && /*#__PURE__*/_jsxs(Row, {
      justifyContent: "end",
      gap: 8,
      className: "".concat(styles.actionRow, " ").concat(hasScroll && !isAtBottom ? styles.actionRowWithScroll : ''),
      children: [canUndo && !isClarification && /*#__PURE__*/_jsx(Button, {
        skin: "primaryOutline",
        size: "small",
        "data-testid": SuggestedDescriptionDisplayTestIds.UndoButton(),
        onClick: handleUndoClick,
        disabled: isInserting || isUndoLoading,
        loading: isUndoLoading,
        children: "Undo"
      }), (() => {
        const isInserted = hasServiceDescriptionAtInsert !== null;
        const shouldShowReplaceButton = isInserted ? hasServiceDescriptionAtInsert : hasServiceDescription;
        if (shouldShowReplaceButton) {
          return /*#__PURE__*/_jsx(Button, {
            size: "small",
            "data-testid": SuggestedDescriptionDisplayTestIds.ReplaceButton(),
            onClick: !isInserted ? handleInsertButtonClick : undefined,
            prefixIcon: isInserted ? /*#__PURE__*/_jsx(CheckSmall, {}) : undefined,
            className: isInserted ? styles.insertedButton : undefined,
            disabled: isUndoLoading,
            children: isInserted ? 'Replaced' : 'Replace'
          });
        }
        return /*#__PURE__*/_jsx(Button, {
          size: "small",
          "data-testid": SuggestedDescriptionDisplayTestIds.InsertButton(),
          onClick: !isInserted ? handleInsertButtonClick : undefined,
          prefixIcon: isInserted ? /*#__PURE__*/_jsx(CheckSmall, {}) : undefined,
          className: isInserted ? styles.insertedButton : undefined,
          disabled: isUndoLoading,
          children: isInserted ? 'Inserted' : 'Insert'
        });
      })()]
    })]
  });
};
export default SuggestedDescriptionDisplay;